<template >
  <b-card title="Bar">
    <b-card img-bottom >
      <ChartBarBase :chart-data="chartData" />
    </b-card>
  </b-card>
</template>

<style>

</style>

<script>
import ChartBarBase from "./ChartBarBase.js";

export default {
  components: {
    ChartBarBase
  },
  data() {
    return {
      chartData: null
    };
  },
  mounted() {
    this.fillData();
  },
  methods: {
    fillData() {
      this.chartData = {
        labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug" , "Sep", "Oct","Nov","Dec"],
        datasets: [
          {
            type:"line",
            backgroundColor: "transparent",
            borderColor: "#de98ab",
            data: [22, 31, 28, 37, 27, 32, 28, 38, 23, 29, 26, 17],
            label: "Previous year"
          },
          {
            type:"bar",
            backgroundColor: "#98ddde",
            borderColor: "#030c0c",
            data: [22, 42, 35, 27, 43, 21, 17, 31, 23, 23, 11, 17],
            label: "This year"
          }
        ]
      };
    }
  }
};
</script>